import { cn } from "../../../../lib/utils";

interface RecoveryDetailsShimmeringProps {
  hideTopHeaderLayout?: boolean;
  sectionCount: number;
}

export const ShimmerBlock = ({ className }: { className: string }) => (
  <div className={cn("bg-gray-200/70 rounded-md", className)} />
);

export const ReportDetailsShimmering: React.FC<RecoveryDetailsShimmeringProps> = (props) => (
  <div className="bg-white rounded-xl overflow-hidden mt-2">
    <div className="px-[10px] py-[6px] bg-gray-50">
      <div className="flex flex-1 items-center gap-2 py-[6px] animate-pulse">
        <ShimmerBlock className="h-6 w-56" />
        <span className="text-gray-300 font-normal">|</span>
        <ShimmerBlock className="h-6 w-40" />
      </div>
    </div>

    <div className="px-6 flex flex-col gap-4 bg-white rounded-b-lg animate-pulse">
      {!props?.hideTopHeaderLayout && (
        <>
          <div className="flex mt-4 items-center justify-between">
            <ShimmerBlock className="h-7 w-40" />
            <div className="flex items-center gap-3 px-[10px]">
              <ShimmerBlock className="h-9 w-24" />
              <ShimmerBlock className="h-9 w-28" />
              <ShimmerBlock className="h-9 w-28" />
            </div>
          </div>
          <ShimmerBlock className="h-5 w-36" />
          <div className="flex gap-6">
            <div className="flex flex-col gap-2 w-56">
              <ShimmerBlock className="h-3 w-44" />
              <ShimmerBlock className="h-7 w-20" />
            </div>
            <div className="w-px h-11 bg-[#E5E5E5] self-center" />
            <div className="flex flex-col gap-2 w-56">
              <ShimmerBlock className="h-3 w-56" />
              <ShimmerBlock className="h-7 w-20" />
            </div>
          </div>
        </>
      )}

      <div className="pt-3 pb-7 px-1">
        <div className="h-px w-full bg-[#E5E5E5]" />
      </div>
    </div>

    <div className="px-6 pb-4 flex flex-col animate-pulse">
      {Array.from({ length: props.sectionCount }).map((_, idx) => {
        const showDivider = idx !== props.sectionCount - 1;

        return (
          <div key={idx} className="flex flex-col">
            <div className="flex w-[352px] py-[6px] px-0 items-start gap-4">
              <ShimmerBlock className="h-5 w-56" />
              <ShimmerBlock className="h-6 w-12 rounded-full" />
            </div>
            {showDivider && (
              <div className="pt-7 pb-7 px-1">
                <div className="h-px w-full bg-[#E5E5E5]" />
              </div>
            )}
          </div>
        );
      })}
    </div>
  </div>
);
